<template>
  <div class="block">
    <el-date-picker v-model="value" type="daterange" align="right" unlink-panels range-separator="to"
      start-placeholder="From" end-placeholder="To" :picker-options="pickerOptions" @change="handleDateChange">
    </el-date-picker>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '2024年',
            onClick(picker) {
              const start = new Date(new Date().getFullYear(), 0, 1);
              const end = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '2023年',
            onClick(picker) {
              const start = new Date(new Date().getFullYear() - 1, 0, 1);
              const end = new Date(new Date().getFullYear() - 1, 11, 31);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '全部时间段',
            onClick(picker) {
              const start = new Date(2021, 8, 2); // 2021年9月1日，注意月份从0开始计数,日期要加1  很奇怪
              const end = new Date(); // 今天
              picker.$emit('pick', [start, end]);
            }
          },
        ]
      },
      value: ''
    };
  },

  mounted() {
    // 默认选择最近三个月
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
    this.value = [start, end];
    this.handleDateChange(this.value);
  },


  methods: {

    handleDateChange(value) {
      const formattedValue = value.map(date => date.toISOString().split('T')[0]).join('to');
      this.$emit('date-change', formattedValue);
    },
  }
};
</script>
